module.exports = __webpack_public_path__ + "static/media/detail_0031_f.b3427da0.jpg";